import { useTranslation } from 'react-i18next';

const HERO_IMG = '/images/story/poli.jpg';

export default function HeroSection() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero__media" aria-hidden="true">
        <img src={HERO_IMG} alt="" loading="eager" {...{ fetchpriority: 'high' }} />
      </div>
      <div className="container hero__inner">
        <p className="hero__location reveal">
          <span aria-hidden="true">◆</span> {t('hero.eyebrow')}
        </p>
        <h1 className="hero__title">
          <span className="hero__title-line"><span>{t('hero.title_line1')}</span></span>
          <span className="hero__title-line"><span>{t('hero.title_line2')}</span></span>
          <span className="hero__title-line"><span><em>{t('hero.title_line3_em')}</em></span></span>
        </h1>
        <p className="hero__lede reveal">{t('hero.lede')}</p>
        <div className="hero__ctas reveal">
          <a href="#inquiry" className="btn btn--gold" onClick={scrollTo('inquiry')}>
            {t('hero.ctaPrimary')}
            <span className="arrow" aria-hidden="true">→</span>
          </a>
          <a href="#apartments" className="btn btn--ghost-light" onClick={scrollTo('apartments')}>
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <a href="#story" className="hero__scroll" onClick={scrollTo('story')} aria-label={t('hero.scroll')}>
          <span>{t('hero.scroll')}</span>
          <span className="hero__scroll-line" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
